/**
 * SiteFooter — single unified footer for every non-home route.
 *
 * iter94 (Cohort P1) — Merged three previously-stacked strips (marketing
 * mini-strip in App.js, the standalone policy strip added in iter93, and
 * the old contact/pricing row) into ONE cohesive footer:
 *   Brand + tagline · Contact · Pricing · Terms · Privacy · Refund
 *   ·······································································
 *   © Nikshala AI attribution · "no visa outcome ever guaranteed" note
 *
 * On `/`, the dark HomeFooter is used instead (see App.js). This footer
 * renders on every other route.
 */
import { Link } from "react-router-dom";

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-16 border-t border-ink/10 bg-paper"
      data-testid="site-footer"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 py-8 flex flex-col md:flex-row md:items-start md:justify-between gap-6">
        {/* brand line — same weight as the product itself, not a footer afterthought */}
        <div className="text-[13px] text-ink/85 leading-relaxed max-w-md">
          <span className="font-bold text-ink">Ministry of Exchange</span>
          <span className="text-muted"> · Visa &amp; relocation for exchange semesters and internships abroad.</span>
        </div>

        {/* combined nav — site links + policy links, one row, no separator strip */}
        <nav
          className="flex flex-wrap items-center gap-x-5 gap-y-2 text-[12px] font-semibold text-ink/80"
          aria-label="Site links"
        >
          <Link to="/pricing"             data-testid="footer-link-pricing" className="hover:text-elec transition-colors">Pricing</Link>
          <Link to="/contact"             data-testid="footer-link-contact" className="hover:text-elec transition-colors">Contact</Link>
          <span className="text-ink/20">·</span>
          <Link to="/terms"               data-testid="footer-link-terms"    className="hover:text-elec transition-colors">Terms</Link>
          <Link to="/privacy"             data-testid="footer-link-privacy"  className="hover:text-elec transition-colors">Privacy</Link>
          <Link to="/security"            data-testid="footer-link-security" className="hover:text-elec transition-colors">Security</Link>
          <Link to="/refund-cancellation" data-testid="footer-link-refund"   className="hover:text-elec transition-colors">Refund &amp; Cancellation</Link>
        </nav>
      </div>

      <div className="border-t border-ink/8">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 py-5 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 text-[11px] text-muted">
          <div>
            © {year} <span className="font-semibold text-ink/80">Nikshala AI</span>. Ministry of Exchange is a sister product under the Nikshala AI family.
          </div>
          <div>No visa outcome is ever guaranteed. Every rule sourced from official government sites.</div>
        </div>
      </div>
    </footer>
  );
}
